import React from "react";
import styles from "./OurMission.module.css";
const OurMission = () => {
  return (
    <div
      style={{
        background: `url(./assets/HF.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "10% 40%",
        position: "relative",
        top: "-20px",
      }}
      className={styles.sectionBody}
    >
      <div className={styles.container}>
        <h2 className={styles.animation}>
          Our Mission
          <hr />
        </h2>
        {/* <p className={styles.animation2}>Future of Railways</p> */}
        <div className={styles.section}>
          <h6>
            SPACE.LABS is an Advanced Engineering development studio built on
            the axiom that creative freedom and independence lead to better,
            more innovative railways. We believe that good work takes
            time—hypothesize, experiment, validate—and take pride in delivering
            excellence.
          </h6>
        </div>
      </div>
    </div>
  );
};

export default OurMission;
